function PriceRangeprogressbar(removeprice){
  var removepricerange = removeprice;
  var filter_min_value = $('#Mobile-Filter-Price-GTE').attr('min');
  var filter_max_value = $('#Mobile-Filter-Price-LTE').attr('max');
  var min_val = Math.round(filter_min_value);
  var max_val = Math.round(filter_max_value);

  var filter_min = $('#Mobile-Filter-Price-LTE').attr('min');
  var filter_max = $('#Mobile-Filter-Price-GTE').attr('max');

  var min = Math.round(filter_min);
  var max = Math.round(filter_max);

  $(".facets__filterprice-content").each(function() {
    // $this is a reference to .slider in current iteration of each
      $this = $(this);
      // find any .slider-range element WITHIN scope of $this
      $(".price-slider-range", $this).slider({
          range: true,
          min: parseInt(min_val),
          max: parseInt(max_val),
          values: [parseInt(min), parseInt(max)],
          change: function(event, ui) {
            document.getElementById("Mobile-Filter-Price-LTE").setAttribute("min", ui.values[ 0 ]);
            $('#Mobile-Filter-Price-GTE').val(ui.values[ 0 ]);
            document.getElementById("Mobile-Filter-Price-GTE").setAttribute("max", ui.values[ 1 ]);
            $('#Mobile-Filter-Price-LTE').val(ui.values[ 1 ]);
            if(removepricerange){
              var priceInput = document.getElementById('Mobile-Filter-Price-LTE');
              var priceinputEvent = new Event('input', {
                  bubbles: true,
                  cancelable: true,
                });
                //priceInput.dispatchEvent(priceinputEvent);
            }else{}
          },
          slide: function( event, ui ) {
              document.getElementById("Mobile-Filter-Price-LTE").setAttribute("min", ui.values[ 0 ]);
              $('#Mobile-Filter-Price-GTE').val(ui.values[ 0 ]);
              document.getElementById("Mobile-Filter-Price-GTE").setAttribute("max", ui.values[ 1 ]);
              $('#Mobile-Filter-Price-LTE').val(ui.values[ 1 ]);
              if(removepricerange){
                var priceInput = document.getElementById('Mobile-Filter-Price-LTE');
                var priceinputEvent = new Event('input', {
                    bubbles: true,
                    cancelable: true,
                  });
                  priceInput.dispatchEvent(priceinputEvent);
              }else{}
          }
      });
  });
    
}

function productGridview(current_view){
  var current_gridcolumn = $(current_view).attr('data-gridcolumn');
  $('.facets-product-viewitem[data-gridcolumn!="'+current_gridcolumn+'"]').removeClass('active-grid');
  $('.facets-product-viewitem[data-gridcolumn="'+current_gridcolumn+'"]').addClass('active-grid');
  if(current_gridcolumn == 3){
    $('.collection-product-grid').removeClass('collection-product-grid-col2').removeClass('collection-product-grid-col1').removeClass('collection-product-grid-list');
    $('.collection-product-grid').addClass('collection-product-grid-col3');
  }else if(current_gridcolumn == 2){
    $('.collection-product-grid').removeClass('collection-product-grid-col3').removeClass('collection-product-grid-col1').removeClass('collection-product-grid-list');
    $('.collection-product-grid').addClass('collection-product-grid-col2');
  }else if(current_gridcolumn == 1){
    $('.collection-product-grid').removeClass('collection-product-grid-col3').removeClass('collection-product-grid-col2');
    $('.collection-product-grid').addClass('collection-product-grid-col1 collection-product-grid-list');
  }
}

function loadContent(url) {
      var current_grid_desktopView =  $('.facets-product-viewfilter .facets-product-viewitem.active-grid');
      var current_grid_mobileView =  $('.collection-filter-mobile-viewicons .facets-product-viewitem.active-grid');
      $.ajax({
          url: url,
          type: 'GET',
          success: function(response) {
              // Update page content
              const collectionhtml = new DOMParser().parseFromString(response, 'text/html');
              const selected_collection_content = collectionhtml.querySelector('.collection-filter-productgrid').innerHTML;
              $('.collection-filter-productgrid').html(selected_collection_content);
              productGridview(current_grid_desktopView);
              productGridview(current_grid_mobileView);
              $('.collection-productwrap .collection').removeClass('loading');
              history.pushState({}, '', `${url}`);
              collectionCategoryclick();
              $('body').removeClass('overflow-hidden-mobile');
               PriceRangeprogressbar(true);
               $('.block__card_product-feature-head').on("click", function () {
                if ($(this).hasClass("show")) {
                    $(this).find('span').text('Show Specs');
                } else {
                    $(this).find('span').text('Hide Specs');
                }
                $(this).toggleClass("show");
                $(this).parents('.product-card-wrapper').toggleClass("show_feature");
                $(this).parent('.block__card_product_feature').find(".block__card_product-feature-content").toggleClass("show");
              });
              $('.facets-product-viewitem').click(function(){
                var current_view = $(this);
                productGridview(current_view);
              });
          },
          error: function(xhr, status, error) {
              console.error(error);
          }
      });
}

function collectionCategoryclick(){
  $('.listcategory-titlewrap').click(function(e) {
    e.preventDefault();
    var url = '';
    if($(this).hasClass('active')){
      $(this).parents('.categoryfilter-listitem').removeClass('listcategory-active');
      $(this).removeClass('active');
      url = $(this).parents('.collection-product-section').attr('data-maincollection');
    }else{
      $('.categoryfilter-listitem').removeClass('listcategory-active');
      $('.listcategory-titlewrap').removeClass('active');
      $(this).parents('.categoryfilter-listitem').addClass('listcategory-active');
      $(this).addClass('active');
      url = $(this).attr('data-categoryhref');
    }
    $('.collection-productwrap .collection').addClass('loading');
    loadContent(url);
  });
}
collectionCategoryclick();

$(document).ready(function(){
  PriceRangeprogressbar(true);

  $('.facets-product-viewitem').click(function(){
    var current_view = $(this);
    productGridview(current_view);
  });

});

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const collection = gridContainer.querySelector('.collection');
      if (collection) collection.classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        console.error('Error fetching filtered collection section:', error);
        document.querySelectorAll('.collection').forEach((el) => el.classList.remove('loading'));
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const gridContainer = document.getElementById('ProductGridContainer');
    const parsedGridContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (gridContainer && parsedGridContainer) {
      gridContainer.innerHTML = parsedGridContainer.innerHTML;
    }
    document
      .getElementById('ProductGridContainer')
      ?.querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    var current_active_grid = $('.facets-product-viewitem.active-grid');
    productGridview(current_active_grid);

    setTimeout(function(){
      var pricesArray = [];
      $(document).find('.product-grid .collection_product-griditem').each(function() {
        var dataprice = parseFloat($(this).attr('data-productprice'));
        if (!isNaN(dataprice)) pricesArray.push(dataprice);
      });

      if (pricesArray.length > 0) {
        var minPriceData = (Math.min.apply(Math, pricesArray)).toFixed(2);
        var maxPriceData = (Math.max.apply(Math, pricesArray)).toFixed(2);
        
        if(maxPriceData == 0){
          $('.price_facet_filter').css('display','none');
        }else{
          $('.price_facet_filter').css('display','block');
        }
      }
    },800);
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCount');
    const countDesktopElement = parsedHTML.getElementById('ProductCountDesktop');
    const count = countElement ? countElement.innerHTML : '';
    const countDesktop = countDesktopElement ? countDesktopElement.innerHTML : count;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = countDesktop;
      containerDesktop.classList.remove('loading');
    }

    // Always remove loading state from collection grid
    document.querySelectorAll('.collection').forEach((el) => el.classList.remove('loading'));

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = (event && event.target) ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            const prevEl = document.getElementById(previousElementId);
            if (prevEl) prevEl.after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const parentJSFilter = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
          if (parentJSFilter) parentJSFilter.before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    setTimeout(function(){
      PriceRangeprogressbar(true);  
    },200);

    if (countsToRender && event && event.target) {
      const closestFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestFilter ? closestFilter.id : null;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, closestFilter);
        const mobileTarget = document.getElementById(closestJSFilterID);
        if (mobileTarget) {
          FacetFiltersForm.renderMobileCounts(countsToRender, mobileTarget);
        }

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
          if (newElementToActivate) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (activeFacetsElement && targetElement) {
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      const targetEl = document.querySelector(selector);
      if (sourceEl && targetEl) {
        targetEl.innerHTML = sourceEl.innerHTML;
      }
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') {
        drawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    return [
      {
        section: productGrid ? productGrid.dataset.id : '',
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event) event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const isMobile = event && event.target && event.target.closest('form') && event.target.closest('form').id === 'FacetFiltersFormMobile';

    if (event && event.srcElement && event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          } else if (form.id === 'FacetSortForm') {
            // Only include sort_by if sort_by is already in URL or user changed sort explicitly
            const urlParams = new URLSearchParams(window.location.search);
            const isSortChanged = event && event.target && (event.target.name === 'sort_by' || event.target.id === 'SortBy');
            if (urlParams.has('sort_by') || isSortChanged) {
              forms.push(this.createSearchParams(form));
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      const searchParams = forms.filter((p) => p && p.length > 0).join('&');
      this.onSubmitForm(searchParams, event);
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);

  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    // if (value < min) input.value = min;
    // if (value > max) input.value = max;

    if (value < min && value != '') input.value = min;
    if (value > max && value != '') input.value = max;
    if (value == '' && min == 0 && max == 0) input.value = min;
    if (value == '' && min != 0) input.value = max;
    setTimeout(function(){
      PriceRangeprogressbar();  
    },1000);

  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
